import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import { Summary } from '@components';
import { iInfringementExtensionFormValues, getSummaryScreen } from '@services/InfringementExtensionService';

function InfringementExtStep8(): ReactElement {
  const { values }: { values: iInfringementExtensionFormValues } = useFormikContext();
  return (
    <div>
      <Summary summaryFields={getSummaryScreen(values)} />
    </div>
  );
}

export default InfringementExtStep8;
